import get from 'transmute/get';
import { createSelector } from 'reselect';
import { getAuth } from '../getAuth';
export const getPortal = createSelector(getAuth, get('portal'));